var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_1467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0399 19.2C12.9559 20.252 11.7599 20.088 10.6199 19.592C9.40789 19.086 8.29989 19.054 7.01989 19.592C5.42589 20.28 4.57989 20.08 3.61989 19.2C-1.80011 13.62 -1.00011 5.12 5.15989 4.8C6.65389 4.88 7.69989 5.626 8.57989 5.688C9.88789 5.422 11.1399 4.66001 12.5399 4.76001C14.2219 4.896 15.4799 5.56 16.3199 6.754C12.8599 8.83399 13.6799 13.394 16.8579 14.674C16.2219 16.344 15.4059 17.994 14.0379 19.214L14.0399 19.2ZM8.45989 4.74001C8.29789 2.26001 10.3079 0.220019 12.6199 0.0200195C12.9379 2.88001 10.0199 5.02 8.45989 4.74001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_1467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.84,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/appleIcon.07612e1abc730ff7df0e6e623b1ee5f7.svg";
export { ForwardRef as ReactComponent };